import { DashboardAppView } from '../view/DashboardAppView';
import { templateDashboardApp } from '../view/template';
import { DashboardAppRepository } from '../repository/DashboardAppRepository';
import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { DashboardAppWebComponent } from '..';
import { TemplateState } from '../../types/common/types';
import { Dashboards } from '../../types';

export class DashboardAppController extends BaseWebComponentController {
  public component: DashboardAppWebComponent;
  public dataRepository: DashboardAppRepository;
  public view: DashboardAppView;
  public viewConstructor: typeof DashboardAppView;
  public dataRepositoryConstructor: typeof DashboardAppRepository;

  constructor(component: DashboardAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: DashboardAppView,
      viewTemplate: templateDashboardApp,
      dataRepositoryConstructor: DashboardAppRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$wrapper,
        event: 'newWidget',
        callback: this.onEventNewWidget,
      },
      {
        element: this.view.dom.$wrapper,
        event: 'removeDashboard',
        callback: this.onEventRemoveDashboard,
      },
      {
        element: this.view.dom.$wrapper,
        event: 'removeWidget',
        callback: this.onEventRemoveWidget,
      },
      {
        element: this.view.dom.$wrapper,
        event: 'newWidgetPositions',
        callback: this.onEventNewWidgetPositions,
      },
    ];
  }

  async onEventRemoveDashboard() {
    await this.render();
    return false;
  }

  async onEventNewWidget() {
    await this.render();
    return false;
  }

  async onEventRemoveWidget() {
    await this.render();
    return false;
  }

  async onEventNewWidgetPositions() {
    await this.render();
    return false;
  }

  async getDataForView(): Promise<Dashboards> {
    this.view.resetTemplateState(this.view.dom.$wrapper);
    this.view.setTemplateState(this.view.dom.$wrapper, TemplateState.LOADING);
    try {
      const dashboards = await this.dataRepository.initDashboards();
      return {
        displayMode: this.component.displayMode,
        ...dashboards,
      };
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.view.resetTemplateState(this.view.dom.$wrapper);
    }
  }
}
